<template>
  <div>
    <van-field
      readonly
      clickable
      name="picker"
      :value="value"
      label="经销商"
      placeholder="点击选择经销商"
      @click="showPicker = true"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>

    <van-field
      v-model="cRemark"
      name="备注"
      label="备注"
      placeholder="请填写备注"
    />
    <div class="subBtn" @click="subForm()">下一步</div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Button, List, Cell, Toast, Form, Field, Popup, Picker } from "vant";

export default {
  data() {
    return {
      value: "",
      columns: [],
      columnsVal: [],
      showPicker: false,
      fCustomerInfoId: 0,
      cRemark: "",
      cCustomerName:""
    };
  },
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
  },
  methods: {
    onConfirm(value, index) {
      this.value = value;
      this.cCustomerName=value;
      this.fCustomerInfoId = this.columnsVal[index];
      this.showPicker = false;
    },
    subForm() {
      if(this.cCustomerName==""){
        Toast("请选择经销商");
        return
      }
      var dd = {
        active: 1,
        fCustomerInfoId: this.fCustomerInfoId,
        cRemark: this.cRemark,
        cCustomerName:this.cCustomerName
      };
      this.$emit("changeData", dd);
    },
  },
  created: function () {
    var _this = this;
    var dd = {
      ticket: sessionStorage.getItem("ticket"),
      page: 1,
      limit: 10000,
    };

    this.$get("/api/PhoneAPI/GetCustomerInfoList", dd)
      .then((res) => {
        if (res.IsSucceed) {
          for (var i = 0; i < res.data.length; i++) {
            _this.columns.push(res.data[i].cName);
            _this.columnsVal.push(res.data[i].id);
          }
        } else {
          Toast(res.Message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
<style scoped>
.searchBox {
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  background: white;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;

  width: 355px;
  z-index: 99;
}
.searchBox img {
  width: 28px;
  flex-shrink: 0;
  height: 28px;
  margin-left: 20px;
}
.searchBox input {
  width: 100%;
  height: 30px;
  border: none;
  box-shadow: 0 0 5px 0 #eee;
  font-size: 12px;
  text-indent: 6px;
}

.numberBox {
  font-size: 20px;
  margin-top: 10px;
}
.subBtn {
  width: 200px;
  margin: 0 auto;
  background: #e62129;
  color: white;
  font-size: 16px;
  border-radius: 5px;
  line-height: 36px;
  height: 36px;
  margin-top: 40px;
}
</style>
